import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ScrollReveal } from '../components/ScrollReveal';

export const MaintenancePage = ({ title = "Page" }) => {
  return (
    <div className="page-wrapper page-maintenance">
      <Header />
      
      {/* Full Page Maintenance Section */}
      <section className="maintenance-section">
        <ScrollReveal>
          <div className="maintenance-content">
            <h1 className="maintenance-title">{title}</h1>
            <div className="maintenance-divider"></div>
            <p className="maintenance-message">
              We&apos;re updating our website.
            </p>
            <p className="maintenance-submessage">
              Check back soon.
            </p>
          </div>
        </ScrollReveal>
      </section>

      <Footer />
    </div>
  );
};
